<div class="container-fluid pt-3">
  <h2 class="accent" style="font-size: 0.9970rem">Application</h2>

  <!-- <button mat-button >
    <mat-icon>account_circle</mat-icon>&nbsp; <b>{{BeneficialOwnerName}}</b>
  </button> -->
  <div class="row justify-content-around" *ngIf="SelectID">
    <div class="col-4 col-sm-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Beneficial Owner Name</mat-label>
        <input matInput name="Bank" [ngModel]="BeneficialOwnerName" readonly>
      </mat-form-field>
    </div>
    <div class="col-5 col-sm-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Bank Name</mat-label>
        <input matInput name="Bank" [ngModel]="Bank" readonly>
      </mat-form-field>
    </div>
    <div class="col-5 col-sm-2">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Branch</mat-label>
        <input matInput name="Branch" [ngModel]="Branch" readonly>
      </mat-form-field>
    </div>
    <div class="col-5 col-sm-2">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Account Number</mat-label>
        <input matInput name="AccountNumber" [ngModel]="AccountNumber" readonly>
      </mat-form-field>
    </div>
    <!-- <div>{{maskNumber(AccountNumber)}}</div> -->
    <!-- <div class="col-4 col-sm-2">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Routing Number</mat-label>
        <input matInput name="RoutingNumber" [ngModel]="RoutingNumber" readonly>
      </mat-form-field>
    </div> -->
    <div class="col-5 col-sm-2" *ngIf="invoice">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>InvoiceNo</mat-label>
        <input matInput name="InvoiceNumber" [ngModel]="InvoiceNumber" readonly>
      </mat-form-field>
    </div>
  
  </div>
 
  


  <form name="applicationData" [formGroup]="applicationData" (ngSubmit)="addData(applicationData.value)">
    <div class="animated fadeIn table-responsive table-w-sticky-header vh-60 mb-2">
      <table class="table table-hover table-condensed table-lt-grey">
        <thead class="cbob-blue-thead table-bordered sticky-header">
          <tr class="headings line-1">
            <th>Beneficiaries</th>
            <th>Select Security</th>
            <th>Rate</th>
            <th>Amount</th>
            <th>Click</th>
          </tr>
        </thead>


        <!-- add row data -->


        <tr class="input-row " *ngFor="let item of objectdata">
          <td class="input-cell">
            <mat-form-field appearance="outline" class="w-100 mat-opaque">
              <mat-label>
                Beneficiary
              </mat-label>
              <input matInput value="{{item.Beneficiaries}}" readonly>
            </mat-form-field>
          </td>


          <td class="input-cell">
            <mat-form-field appearance="outline" class="w-100 mat-opaque">
              <mat-label>
                Security ID
              </mat-label>
              <input matInput value="{{item.SecurityID}}" readonly >
            </mat-form-field>

          </td>


          <td class="input-cell" *ngIf="rateenable">
            <mat-form-field appearance="outline" class="w-100 mat-opaque">
              <mat-label>
                Rate
              </mat-label>
              <input matInput name="rate" value="{{item.rateamount|number:'1.2-2'}}" id="rate" type="text"
                placeholder="Rate" readonly>
            </mat-form-field>
          </td>

          <td class="input-cell">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>
                Amount
              </mat-label>
              <input matInput value="{{item.amount|number:'1.2-2'}}" readonly>
            </mat-form-field>
          </td>
          <td>
            <button mat-flat-button class=" mb-2" type="button" color="primary" (click)="deleteConfirm(item)">

              <mat-icon>remove</mat-icon>
            </button>
          </td>
        </tr>








        <!-- added record -->

        <tr class="input-row">

          <td class="input-cell">
            <mat-form-field appearance="outline" class="w-100 mat-opaque">
              <mat-label>
                Select Beneficiary
              </mat-label>

              <mat-select formControlName="Beneficiaries" (selectionChange)="SelectionCustomerID($event.value)">
                <mat-option *ngFor="let item of Beneficiaries" value="{{item.customerAccountCode}}">

                  <p style="color:rgb(21, 113, 206)">{{item.customerAccountCode}} </p>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </td>

          <td class="input-cell">
            <mat-form-field appearance="outline" class="w-100 mat-opaque">
              <mat-label>
                Select Security ID
              </mat-label>
              <mat-select formControlName="SecurityID" (selectionChange)="SelectionSecurityID($event.value)">
                <mat-option *ngFor="let item of security" value="{{item }}">
                  <!-- <span *ngIf="item===''">SecurityID</span>-->
                  <p style="color:rgb(21, 113, 206)">{{item}} </p>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </td>


          <td class="input-cell" *ngIf="rateenable && test">
            <mat-form-field appearance="outline" class="w-100 mat-opaque">
              <mat-label>
                Rate
              </mat-label>
              <input matInput name="rate" value="{{Rate|number:'1.2-2'}}"  id="rate" type="text" placeholder="Rate"
                readonly>

            </mat-form-field>
          </td>


          <td class="input-cell">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>
                Amount
              </mat-label>
              <input matInput name="checkno" value="{{applicationAmount|number:'1.2-2'}}"
                (change)="changeAmount($event.target.value)" [formControl]="amounttest" id="checkno" type="text"
                placeholder="Amount">
            </mat-form-field>
          </td>

          <td class="button-cell">
            <button mat-flat-button class=" mb-2" type="submit" color="primary">
              <mat-icon>add</mat-icon>
            </button>&nbsp;

          </td>

        </tr>

      </table>  
      <!-- <a  ><mat-checkbox [(ngModel)]="isTermsChecked" (change)="TermsAndConditionsForm($event)" [disabled]="isCheckboxDisabled" style="color: rgb(59, 130, 158);" ><span style="text-decoration: underline;">
        Disclaimer,Terms and Conditions</span></mat-checkbox></a> -->
        <!-- <a >
          <mat-checkbox 
            [(ngModel)]="isTermsChecked" 
            (change)="TermsAndConditionsForm($event)" 
            [disabled]="isCheckboxDisabled" 
            style="color: black;"> -->
            <!-- style="color: rgb(59, 130, 158);"> -->
            <!-- style="text-decoration: underline; font-weight: bold; color: #1e40af;" -->
            <!-- <span  
               onmouseover="this.style.color='black'; this.style.cursor='pointer';"
              onmouseout="this.style.color='black';"> -->
              <!-- Disclaimer, Terms and Conditions -->
               <!-- I Accept all the <span style="text-decoration: underline; font-weight: bold; color: #1e40af;">Disclaimer,Terms and Conditions.</span><br> and confirm that I have read, understood and agree <br> to the Bank's terms and conditions, and acknowledge the Banks Disclaimer 
            </span>
          </mat-checkbox>
        </a> -->
        <a>
          <mat-checkbox 
            [(ngModel)]="isTermsChecked" 
            (change)="TermsAndConditionsForm($event)" 
            [disabled]="isCheckboxDisabled"
            style="vertical-align: middle; color: black;">
            <span>
              I Accept all the 
              <span style="text-decoration: underline; font-weight: bold; color: #1e40af;">
                Disclaimer, Terms and Conditions.
              </span>
              <br>
              and confirm that I have read, understood, and agree to the<br><span style="color: rgb(16, 82, 108);"> Bank's terms and conditions, and acknowledge the Bank's Disclaimer.</span>
            </span>
          </mat-checkbox>
        </a>
      <!-- <p>Checkbox Value: {{ isTermsChecked }}</p> -->
      <br>
      <button  mat-flat-button  class="mb-2"  (click)="SaveData()"  type="button" color="primary" [disabled]="!isTermsChecked">
        Save
      </button>
    </div>
  </form>
</div>
<div class="mat-spinner-fullscreen" [hidden]="loadingData1">
  <mat-spinner style="margin:0 auto;" class="pink-spinner .mat-spinner-bar-buffer" mode="indeterminate">
  </mat-spinner>
</div>